import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatTableModule} from '@angular/material/table';
import { MatSortModule} from '@angular/material/sort';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatRadioModule} from '@angular/material/radio';
import {MatDialogModule} from '@angular/material/dialog';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatChipsModule} from '@angular/material/chips';
import {MatBadgeModule} from '@angular/material/badge';
import {MatListModule} from '@angular/material/list';



@NgModule({
    declarations: [],
    imports: [
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        MatTreeModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatSelectModule,
        MatSortModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTabsModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatCardModule,
        MatStepperModule,
        MatRadioModule,
        MatDialogModule,
        MatProgressBarModule,
        MatChipsModule,
        MatBadgeModule,
        MatListModule
    ],
    exports: [
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        MatTreeModule,
        MatButtonModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatSelectModule,
        MatSortModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTabsModule,
        MatSnackBarModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatExpansionModule,
        MatCardModule,
        MatStepperModule,
        MatRadioModule,
        MatDialogModule,
        MatProgressBarModule,
        MatChipsModule,
        MatBadgeModule,
        MatListModule
    ]
})
export class AngularMaterialModule {}